import { render, staticRenderFns } from "./ModalDetailHistory.vue?vue&type=template&id=7781e882"
import script from "./ModalDetailHistory.vue?vue&type=script&lang=js"
export * from "./ModalDetailHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailHistory.vue?vue&type=style&index=0&id=7781e882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports